import { render, staticRenderFns } from "./ApptCall.vue?vue&type=template&id=8970870a&scoped=true"
import script from "./ApptCall.vue?vue&type=script&lang=js"
export * from "./ApptCall.vue?vue&type=script&lang=js"
import style0 from "./ApptCall.vue?vue&type=style&index=0&id=8970870a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8970870a",
  null
  
)

export default component.exports